import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import {
  Dropdown,
  Container,
  Grid,
  Icon,
  List,
  Menu,
  Message,
  Segment,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import qs from 'qs';
import config from '../../../../../config';
import { fetchM } from '../../../../actions/fetchM';
import { flashErrorMessage } from '../../../../actions/flash';
import NavBar from '../../../../components/NavBar';
import { decodeSearch } from '../../../../utils/url';
import ComponentList from './ComponentList';
import UnitList from './UnitList';

moment.locale('en-gb');

class HIMSUnitSync extends Component {
  static propTypes = {
    params: PropTypes.shape({
      himsSettingID: PropTypes.string,
      componentID: PropTypes.string,
    }),
    id: PropTypes.string,
    project: PropTypes.object,
    loading: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      query: PropTypes.object,
    }),
    auth: PropTypes.shape({
      user: PropTypes.shape({
        isHeadquarters: PropTypes.bool,
        isSuperAdmin: PropTypes.bool,
        isBranchLeaderSupervisorII: PropTypes.bool,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const himsSettingID = props.params.himsSettingID || '';
    const componentID = props.params.componentID || '';
    return {
      himsSettingID,
      componentID,
    };
  }
  constructor(props) {
    super(props);
    const state = HIMSUnitSync.getPropsToState(props);
    const windowWidth = window.innerWidth;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    const isMobile = windowWidth < 768;
    const isLargeScreen = windowWidth >= 1200;
    const topMenuIsTab = windowWidth <= 590;
    this.state = {
      ...state,
      isMobile,
      isTablet,
      isLargeScreen,
      topMenuIsTab,
      loading: true,
      himsSettings: [],
      componentData: [],
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    const { store } = this.context;
    const { query } = this.props.location;
    if (!this.hasAccess()) {
      store.dispatch(replace('/forbidden/'));
      return;
    }
    this.fetchHimsSettings(query);
  }
  componentWillReceiveProps(nextProps) {
    const state = HIMSUnitSync.getPropsToState(nextProps);
    const newQuery = decodeSearch(nextProps.location.search);
    const shouldFetchComponents = (
      state.himsSettingID &&
      nextProps.params.himsSettingID !== this.props.params.himsSettingID
    );
    this.setState({ ...state }, () => {
      if (shouldFetchComponents) {
        this.fetchComponents(newQuery);
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState = (state = {}) => new Promise((res) => {
    this.setState(state, () => {
      res(state);
    });
  })
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  getTabName = () => {
    const { pathname } = this.props.location;
    const { id } = this.props;
    const { himsSettingID } = this.state;
    if (
      pathname === `/projects/${id}/units/hims/` ||
      pathname === `/projects/${id}/units/hims/${himsSettingID}/`
    ) {
      return 'components';
    }
    return 'units';
  }
  fetchHimsSettings = async (q = {}) => {
    await this.setLoading(true);
    const { store } = this.context;
    const { id } = this.props;
    const { pathname } = this.props.location;
    let { himsSettingID } = this.state;

    const query = Object.assign({}, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${id}/hims/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const himsSettings = await res.json() || [];

      if (!himsSettingID && himsSettings && himsSettings.length > 0) {
        himsSettingID = himsSettings[0].id;
      }
      await this.setComponentState({
        himsSettings,
        himsSettingID,
        componentID: '',
      });
      if (himsSettingID && pathname === `/projects/${id}/units/hims/`) {
        store.dispatch(replace(`/projects/${id}/units/hims/${himsSettingID}/`));
      }
    }
    await this.setLoading(false);

    if (himsSettingID) {
      const newQuery = decodeSearch(this.props.location.search);
      this.fetchComponents(newQuery);
    }
  }
  fetchComponents = async (q = {}) => {
    await this.setLoading(true);
    const { store } = this.context;
    const { id } = this.props;
    const { himsSettingID } = this.state;
    const { pathname } = this.props.location;
    let { componentID } = this.state;

    const query = Object.assign({}, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${id}/hims/${himsSettingID}/components/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const componentData = await res.json() || [];
      if (componentData && componentData.length > 0) {
        componentID = componentData[0].pembangunan_id;
      }
      await this.setComponentState({
        componentData,
        componentID,
      });
      if (componentID && pathname.startsWith(`/projects/${id}/units/hims/${himsSettingID}/components/`)) {
        store.dispatch(replace(`/projects/${id}/units/hims/${himsSettingID}/components/${componentID}/`));
      }
    }
    await this.setLoading(false);
  }
  hasAccess = (check = false) => {
    const user = this.props.auth;
    if (user.isHeadquarters || user.isSuperAdmin) {
      return true;
    }
    if (user.isBranchLeaderSupervisorII && this.props.project && (this.props.project.maOwnerCompanyBranchID === user.companyBranch.id)) {
      return true;
    }
    return check;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const topMenuIsTab = windowWidth <= 590;
    const isMobile = windowWidth < 768;
    const isTablet = windowWidth >= 768 && windowWidth < 992;
    const isLargeScreen = windowWidth >= 1200;
    if (topMenuIsTab !== this.state.topMenuIsTab) {
      state.topMenuIsTab = topMenuIsTab;
    }
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
    }
    if (isTablet !== this.state.isTablet) {
      state.isTablet = isTablet;
    }
    if (isLargeScreen !== this.state.isLargeScreen) {
      state.isLargeScreen = isLargeScreen;
    }
    this.setState({ ...state });
  }
  hideUnitsTab = () => {
    const { componentID } = this.state;
    if (componentID) {
      return false;
    }
    if (this.getTabName() === 'units') {
      return false;
    }
    return true;
  }
  render() {
    const { pathname } = this.props.location;
    const { id, project } = this.props;
    const {
      himsSettings,
      himsSettingID,
      componentData,
      componentID,
      isMobile,
      isTablet,
      isLargeScreen,
      topMenuIsTab,
    } = this.state;
    const isLoading = this.props.loading || this.state.loading;
    const links = [
      { text: 'List of components', value: `/projects/${id}/units/hims/${himsSettingID}/` },
      !this.hideUnitsTab() && { text: 'Unit list', value: `/projects/${id}/units/hims/${himsSettingID}/components/${componentID ? `${componentID}/` : ''}` },
    ];
    const messagesList = [
      {
        title: 'Retrieve Component ID and Unit Information',
        description: 'Use this page to access the Component ID (Pembangunan ID) and view all associated unit information',
      },
      {
        title: 'Verify Data Accuracy',
        description: 'Double-check that all details, such as unit number, unit size, and unit price, are accurate',
      },
      {
        title: 'Correcting Errors',
        description: 'If you discover any discrepancies, promptly correct them in the unit settings',
      },
    ];

    return (
      <Container>
        <NavBar
          header="HIMS unit sync"
          links={
            topMenuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
              :
              links.map((link, key) => (
                <Menu.Item
                  key={key}
                  name={link.text}
                  active={pathname === link.value}
                  onClick={e => this.handleMenu(e, link)}
                />
              ))
          }
        />
        <Grid.Column width={16} textAlign="center">
          <div className="hims_notice">
            <Message icon attached>
              <Icon style={{ fontSize: '20px' }}>
                <img alt="info" src="/assets/icons/info_blue.svg" />
              </Icon>
              Important: Ensuring Data Accuracy for Seamless Workflow with HIMS
            </Message>
            <Segment attached>
              To ensure a smooth workflow and prevent errors, it is crucial that all unit information is matched with the HIMS database. Follow these steps to maintain data integrity:
              <List as="ol">
                {messagesList.map((message, mid) => (
                  <List.Item as="li" key={mid}>
                    <span style={{ color: '#00233B', fontWeight: '700' }}>{message.title}</span>
                    :
                    &nbsp;
                    {message.description}.
                  </List.Item>
                ))}
              </List>
            </Segment>
          </div>
          {this.getTabName() === 'components' &&
            <ComponentList
              id={id}
              project={project}
              himsSettings={himsSettings}
              data={componentData}
              loading={isLoading}
              isTablet={isTablet}
              isMobile={isMobile}
            />
          }
          {this.getTabName() === 'units' &&
            <UnitList
              id={id}
              himsSettingID={himsSettingID}
              componentID={componentID}
              himsSettings={himsSettings}
              componentData={componentData}
              loading={isLoading}
              isLargeScreen={isLargeScreen}
              isTablet={isTablet}
              isMobile={isMobile}
            />
          }
        </Grid.Column>
      </Container>
    );
  }
}

export default connect(HIMSUnitSync.mapStateToProps)(HIMSUnitSync);



// WEBPACK FOOTER //
// ./src/containers/Project/Units/HIMSUnitSync/HIMSUnitSync.jsx